import { render, staticRenderFns } from "./ConsumerLinkedBankAccounts.vue?vue&type=template&id=0caf57a5&scoped=true"
import script from "./ConsumerLinkedBankAccounts.vue?vue&type=script&lang=ts"
export * from "./ConsumerLinkedBankAccounts.vue?vue&type=script&lang=ts"
import style0 from "./ConsumerLinkedBankAccounts.vue?vue&type=style&index=0&id=0caf57a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0caf57a5",
  null
  
)

export default component.exports